import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Skeleton, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useNavigate } from "react-router";

import { useGetSearchTrendingQuery } from "~/feature/search/searchApi";
import { buildSearchResultsUrl } from "~/feature/search/utils/buildSearchResultsUrl";

import * as Styled from "./TrendingSection.styles";

interface ITrendingSectionProps {
  onNavigate?: () => void;
}

export const TrendingSection: FC<ITrendingSectionProps> = ({ onNavigate }) => {
  const navigate = useNavigate();
  const { data: items, isLoading } = useGetSearchTrendingQuery();

  if (!isLoading && (!items || items.length === 0)) return null;

  const handleClick = (query: string) => {
    navigate(buildSearchResultsUrl(query));
    onNavigate?.();
  };

  return (
    <Stack
      sx={{
        gap: 0.5,
        px: 1.5,
        py: 1.25
      }}>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5
        }}>
        Popular
      </Typography>
      <Stack>
        {isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
            <Styled.Item key={i}>
              <Skeleton width={160} height={20} />
            </Styled.Item>
          ))
          : items?.map((query) => (
            <Styled.Item
              key={query}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleClick(query)}
            >
              <TrendingUpIcon fontSize="small" color="disabled" />
              <Typography variant="body2" sx={{ textTransform: "capitalize" }}>{query}</Typography>
            </Styled.Item>
          ))}
      </Stack>
    </Stack>
  );
};
